import { render, staticRenderFns } from "./TopCustomersRanking.vue?vue&type=template&id=4204d140&scoped=true&"
import script from "./TopCustomersRanking.vue?vue&type=script&lang=js&"
export * from "./TopCustomersRanking.vue?vue&type=script&lang=js&"
import style0 from "./TopCustomersRanking.vue?vue&type=style&index=0&id=4204d140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204d140",
  null
  
)

export default component.exports